<template>
  <div class="col-sm-12 col-xs-12 col-md-12 modules">
    <div class="form-group mt-10">Add Module</div>
    <div class="row label_container">
      <span class="checkbox mr-12">
        <label>
          <input type="checkbox" v-model="moduleAccess" />
          <span class="cr"></span>
        </label>
      </span>
      <input type="text" v-model="moduleName" class="form-control" />
      <button
        type="button"
        class="btn emergo-green-button"
        :disabled="moduleName.length == 0"
        @click="moduleButton"
      >
        Save
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['serviceModule'],
  data() {
    return {
      moduleAccess: true,
      moduleName: ''
    };
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    moduleButton() {
      const flag = this.serviceModule.modules.some((module) => {
        if (module.name.toLowerCase() === this.moduleName.toLowerCase()) {
          return true;
        }
        return false;
      });
      if (!flag) {
        let newModuleId = 0;
        if (this.serviceModule.modules.length > 0) {
          newModuleId = this.serviceModule.modules[this.serviceModule.modules.length - 1].id; // last module_id
        }
        this.serviceModule.modules.push({
          access: this.moduleAccess,
          name: this.moduleName,
          id: newModuleId + 1,
          operations: []
        });
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Module Already Exists!',
          group: 'custom-notification'
        });
      }
      this.moduleName = '';
    }
  }
};
</script>
<style scoped lang="scss">
.label_container {
  display: flex;
  align-items: center;
  margin-left: 1px;
  padding: 0px 10px 5px 0px;
  border-bottom: 0.5px solid $gray74;
}
.label_container {
  > button {
    width: 25%;
    margin-left: 5px;
  }
}
.form-control {
  width: 45%;
}
@media screen and (max-width: 767px) {
  .cust_checkbox {
    margin-left: 5px !important;
  }
}
</style>
